import '../plugins/fancyboxPlugin';

// lightbox init
export default function initFancybox() {
	jQuery('a.lightbox, [data-fancybox]').fancybox({
		parentEl: 'body',
		margin: [50, 0],
		speed: 0,
		baseClass: 'set-up-popup'
	});
	jQuery('[data-fancybox]').fancybox({
		smallBtn : true
	});
}